import React, { Component } from "react";
import {
    Layout,
    Row,
    Col,
    Menu,
    Typography,
} from "antd";
import logoHorizontal from "../../assets/Biwo_Horizontal.png";
import { NavLink } from "react-router-dom";

const { Header, Footer, Content } = Layout;
const { Title, Paragraph } = Typography;

class PoliticaCancelacion extends Component {
    render() {
        const current = this.props.history.location.pathname;
        return (
            <Layout>
                <Header id="header-fixed">
                    <Menu
                        mode="horizontal"
                        selectedKeys={[current]}
                        style={{ height: "100%" }}
                        id="menu-centered"
                    >
                        <Menu.Item key="/login" id="menuitem-izquierda">
                            <NavLink to="/login">
                                <img src={logoHorizontal} alt="Logo" id="img-logo" />
                            </NavLink>
                        </Menu.Item>
                    </Menu>
                </Header>
                <Content style={{ marginTop: 64 }}>
                    <Row justify="center" style={{ padding: '2rem' }}>
                        <Col xs={24} sm={22} md={20} lg={16} xl={14}>
                            <Typography style={{ whiteSpace: 'pre-wrap' }}>
                                <Title level={1} style={{ textAlign: 'center' }}>
                                    Política de Cancelación y Devolución
                                </Title>
                                <Paragraph><strong>Última actualización:</strong> 15 de mayo de 2025</Paragraph>

                                <Paragraph>
                                    En BIWO, buscamos ofrecer claridad y transparencia en la administración de las cancelaciones y devoluciones. Esta política aplica a todos los usuarios que contraten nuestros servicios bajo cualquier modalidad.
                                </Paragraph>

                                <Title level={2}>1. Cancelación por parte del usuario</Title>
                                <Paragraph>
                                    Puedes cancelar tu suscripción en cualquier momento desde tu cuenta o enviando un correo a <a href="mailto:soporte@biwo.mx">soporte@biwo.mx</a>. La cancelación será efectiva al finalizar el periodo pagado. No se realiza devolución por días no utilizados.
                                </Paragraph>

                                <Title level={2}>2. Suspensión por falta de pago</Title>
                                <Paragraph>
                                    BIWO opera bajo un modelo de prepago. Si no se realiza el pago correspondiente antes del inicio del ciclo, el acceso será suspendido automáticamente. Para reactivar el servicio, el usuario deberá cubrir todos los meses vencidos.
                                </Paragraph>

                                <Title level={2}>3. Cancelación por parte de BIWO</Title>
                                <Paragraph>
                                    BIWO se reserva el derecho de suspender o cancelar cuentas por impago, incumplimiento de los Términos y Condiciones, uso indebido del sistema o sospechas de fraude. En estos casos, no se otorgarán reembolsos.
                                </Paragraph>

                                <Title level={2}>4. Política de Reembolsos</Title>
                                <Paragraph>
                                    No se realizarán devoluciones por periodos ya facturados. Solo en caso de fallas técnicas imputables a BIWO que imposibiliten el uso del sistema durante más de 72 horas consecutivas, se podrá solicitar un reembolso proporcional del periodo afectado enviando evidencia al correo <a href="mailto:soporte@biwo.mx">soporte@biwo.mx</a>.
                                </Paragraph>

                                <Title level={2}>5. Servicios no reembolsables</Title>
                                <Paragraph>
                                    No son reembolsables los pagos realizados por:
                                    <ul>
                                        <li>Planes anuales ya activados.</li>
                                        <li>Venta de timbres fiscales.</li>
                                        <li>Desarrollos personalizados.</li>
                                        <li>Capacitación o integraciones especiales.</li>
                                    </ul>
                                    Estos servicios son considerados entregables digitales de consumo inmediato o trabajo a medida.
                                </Paragraph>

                                <Title level={2}>6. Reactivación del servicio</Title>
                                <Paragraph>
                                    El usuario puede reactivar su cuenta en cualquier momento, siempre que liquide los montos adeudados. La reactivación está sujeta a revisión técnica y administrativa por parte del equipo de BIWO.
                                </Paragraph>

                                <Title level={2}>7. Contacto</Title>
                                <Paragraph>
                                    Para gestionar la cancelación, solicitar un reembolso proporcional por interrupciones del servicio, o resolver dudas, comunícate con nosotros al correo <a href="mailto:soporte@biwo.mx">soporte@biwo.mx</a>.
                                </Paragraph>
                            </Typography>
                        </Col>
                    </Row>
                </Content>
                <Footer id="content-background" style={{ textAlign: "center" }}>
                    Biwo ©2026
                </Footer>
            </Layout>
        );
    }
}

export default PoliticaCancelacion;